/** Max length for profile tagline (Role / tagline field). */
export const PROFILE_TAGLINE_MAX = 120;

/** Max length for profile location field. */
export const PROFILE_LOCATION_MAX = 80;

/** Trim optional profile text; empty or whitespace-only becomes null. */
export function normalizeProfileOptionalText(value: string | null | undefined): string | null {
  if (value == null) return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}
